import { useNavigate } from "react-router-dom";

export default function PublicHeader({ crumbLabel }) {
  const navigate = useNavigate();
  return (
    <header className="nav on-dark" data-testid="public-header">
      <button className="nav__brand" onClick={() => navigate("/")} data-testid="public-home">
        <span className="nav__logo">EQUIPR</span>
        <span className="nav__academy">Academy</span>
      </button>
      {crumbLabel && (
        <div className="nav__crumbs">
          <span className="nav__slash">/</span>
          <span className="crumb crumb--product">{crumbLabel}</span>
        </div>
      )}
      <div className="nav__right">
        <a className="nav__link" href="https://help.equipr.software" target="_blank" rel="noreferrer" data-testid="public-help">Help Center</a>
        <button className="nav__cta" onClick={() => navigate("/login")} data-testid="public-signin">Sign in</button>
      </div>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="footer on-dark">
      <span className="footer__brand">ACADEMY.EQUIPR.SOFTWARE &nbsp;·&nbsp; V1.0</span>
      <span className="footer__note">Products are separate courses under one shell. Nothing is shared between them.</span>
    </footer>
  );
}
